export const maxSize = 1024 * 10
export const imageTypes = ["image/jpg","image/png", "image/jpeg"]
export const acceptTypes = ["jpg", "png", "jpeg"]